export default __webpack_public_path__ + "static/media/JOSA CLASS-6_SYLLABUS_2025-26.95a8cf6b.pdf";